var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadDisabledGrayBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38,
    rx: 6,
    fill: "#D3D3D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8825_1837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 11.416L19.1511 10.5675L19.9997 9.71896L20.8482 10.5675L19.9997 11.416ZM21.1997 21.166C21.1997 21.8288 20.6624 22.366 19.9997 22.366C19.3369 22.366 18.7997 21.8288 18.7997 21.166L21.1997 21.166ZM13.7345 15.9842L19.1511 10.5675L20.8482 12.2645L15.4315 17.6812L13.7345 15.9842ZM20.8482 10.5675L26.2649 15.9842L24.5678 17.6812L19.1511 12.2645L20.8482 10.5675ZM21.1997 11.416L21.1997 21.166L18.7997 21.166L18.7997 11.416L21.1997 11.416Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.417 23.334L12.417 24.4173C12.417 25.6139 13.387 26.584 14.5837 26.584L25.417 26.584C26.6136 26.584 27.5837 25.6139 27.5837 24.4173V23.334",
    stroke: "#8F8F8F",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.417,
    y: 22.25,
    width: 15.1667,
    height: 4.33333,
    rx: 2,
    fill: "#7E869E",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8825_1837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDisabledGrayBg);
export default __webpack_public_path__ + "static/media/upload_disabled_grayBG.480d9223b44ab8cde242135a84bd215c.svg";
export { ForwardRef as ReactComponent };